import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            this.initSocial();
            this.initBlog();
        }
        this.initProperties();
    }

    initProperties() {
        if(document.querySelector('#properties')){
            new Swiper('#properties .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                // autoplay: {
                //     delay: 2500,
                // },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                    }
                },
                navigation: {
                    nextEl: '#properties .swiper-button-next',
                    prevEl: '#properties .swiper-button-prev',
                }
            });
        }
    }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            // autoplay: {
            //     delay: 2500,
            // },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }

    initBlog() {
        new Swiper('#blog .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            // autoplay: {
            //     delay: 2500,
            // },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                }
            }
        });
    }

}
